import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {loadRegions, createRegion, saveRegionState, deleteRegion} from '../../actions/regionActions';
import {loadUnmappedSuburbs, saveSuburbToRegion, removeSuburbFromRegion} from '../../actions/suburbActions';
import { Button, Collapse, Label, Input, FormGroup} from 'reactstrap';
import {find, some} from 'lodash';

class ManageRegionsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedRegion: null,
      selectedSuburb: null,
      assignedRegion: 0,
      newRegion: { create: false, name: '', isInactive: false}
    };
    this.handleRegionClick = this.handleRegionClick.bind(this);
    this.handleSuburbClick = this.handleSuburbClick.bind(this);
    this.handleRegionAssignTo = this.handleRegionAssignTo.bind(this);
    this.handleSaveAssignSuburbToRegion = this.handleSaveAssignSuburbToRegion.bind(this);
    this.handleSaveAssignSuburbFromRegion = this.handleSaveAssignSuburbFromRegion.bind(this);
    this.handleRemoveSuburbFromRegion = this.handleRemoveSuburbFromRegion.bind(this);
    this.handleCreateRegion = this.handleCreateRegion.bind(this);
    this.handleSetRegionActive = this.handleSetRegionActive.bind(this);
    this.handleDeleteRegion = this.handleDeleteRegion.bind(this);
  }

  handleRegionClick(evnt, region){
    if(evnt){
      evnt.preventDefault();
    }
    this.setState({selectedRegion: region});
  }

  handleSuburbClick(evnt, suburb){
    if(evnt){
      evnt.preventDefault();
    }
    this.setState({selectedSuburb: suburb});
  }

  handleRegionAssignTo(e){
    this.setState({assignedRegion: e.target.value});
  }

  handleSaveAssignSuburbFromRegion(suburb){
    if(!this.state.selectedRegion || !suburb){
      return;
    }
    this.props.dispatch(saveSuburbToRegion(suburb, this.state.selectedRegion.id));
  }

  handleSaveAssignSuburbToRegion(){
    if(!this.state.selectedSuburb || this.state.assignedRegion == 0){
      return;
    }
    this.props.dispatch(saveSuburbToRegion(this.state.selectedSuburb, this.state.assignedRegion));
    this.setState({selectedSuburb: null, assignedRegion: 0});
  }

  handleRemoveSuburbFromRegion(suburb){
    if(!this.state.selectedRegion || !suburb){
      return;
    }
    this.props.dispatch(removeSuburbFromRegion(suburb, this.state.selectedRegion.id));
  }

  handleCreateRegion(){
    if(this.state.newRegion.create && this.state.newRegion.name.trim() == ''){
      return;
    }
    this.props.dispatch(createRegion(this.state.newRegion));
  }

  handleSetRegionActive(e){
    let selectedRegion = {...this.state.selectedRegion};
    selectedRegion.isInactive = !e.target.checked;
    console.log(selectedRegion);
    this.setState({selectedRegion});
    this.props.dispatch(saveRegionState(selectedRegion));
  }

  handleDeleteRegion(e){
    if(confirm('Delete region, all region suburb assignments will be lost')){
      this.props.dispatch(deleteRegion(this.state.selectedRegion));
      this.setState({selectedRegion: null});
    }
  }

  static getDerivedStateFromProps(props, state) {
    let {selectedRegion, newRegion} = state;

    if(newRegion.create){
      let found = _.find(props.regions.items, x => !_.some(props.regions.items, y => y.id === x.id));
      if(found){
        selectedRegion =  found;
        newRegion = {create: false, name: '', isInactive: false};
        
        return {...state, selectedRegion, newRegion};
      }
    }

    if(selectedRegion){
      selectedRegion = _.find(props.regions.items, x => x.id === selectedRegion.id);
      return {...state, selectedRegion};
    }
    
    return null;
  }

  componentDidMount(){
    this.props.dispatch(loadRegions());
    this.props.dispatch(loadUnmappedSuburbs());
  }

  render(){
    return (<div>
      <Collapse isOpen={!this.state.selectedRegion && !this.state.selectedSuburb && !this.state.newRegion.create}>
        <div className="row">
          <div className="col-md-12">
            <h4>Unassigned Suburbs</h4>
            <table className="table">
              <thead>
              <tr>
                <th>Suburb</th>
                <th>&nbsp;</th>
              </tr>
              </thead>
              <tbody>
              {this.props.unmappedSuburbs.items.length==0 && <tr><td>There are no unmapped suburbs</td><td>&nbsp;</td></tr>}
              {this.props.unmappedSuburbs.items.map(x => {
                return (<tr key={x.id}>
                  <td>{x.name} - {x.postcode}</td>
                  <td><a href="#" onClick={(e) => this.handleSuburbClick(e, x)}>Assign to region</a></td>
                </tr>);
              })}
              </tbody>
            </table>
          </div>
        </div>
      </Collapse>
      <Collapse isOpen={!this.state.selectedRegion && !this.state.selectedSuburb && !this.state.newRegion.create}>
        <div className="row">
          <div className="col-md-12">
            <h4>Regions <Button color="success" onClick={()=>this.setState({newRegion: {create: true, name: '', isInactive: false}})}><i className="fa fa-plus" />&nbsp;Add region</Button></h4>
            <table className="table">
              <thead>
              <tr>
                <th>Region</th>
                <th>Active</th>
                <th># Suburbs</th>
              </tr>
              </thead>
              <tbody>
              {this.props.regions.items.map(x => {
                return (<tr key={x.id}>
                  <td><a href="#" onClick={(e) => this.handleRegionClick(e, x)}>{x.name}</a></td>
                  <td><i className={x.isInactive ? 'fa fa-times': 'fa fa-check'} /></td>
                  <td>{x.suburbs.length}</td>
                </tr>);
              })}
              </tbody>
            </table>
          </div>
        </div>
      </Collapse>
      {this.state.selectedRegion && !this.state.newRegion.create && <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <h4>Edit {this.state.selectedRegion.name}&nbsp;<a href="#" className="text-muted"  onClick={(e)=> {
              e.preventDefault();
              this.setState({selectedRegion: null});
            }}>done</a></h4>
          </div>
        </div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <strong>Is Active&nbsp;</strong>
            <label className="switch switch-3d switch-success">
              <input type="checkbox"
                     checked={!this.state.selectedRegion.isInactive}
                     className="switch-input"
                     onChange={(e) => this.handleSetRegionActive(e)}
              />
              <span className="switch-label" />
              <span className="switch-handle" />
            </label>
          </div>
        </div>

        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
                <Button color="danger" onClick={this.handleDeleteRegion}><i className="fa fa-trash" />&nbsp;Delete Region</Button>
              </div>
        </div>

        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <h6>Suburb assignment</h6>
            <div className="form-horizontal">
              <div className="form-group row">
                <h6 className="hidden-md-up">Unassigned Suburbs</h6>
                <ul className="col-md-6 list-group" style={{marginBottom:'10px'}}>
                  {this.props.unmappedSuburbs.items.length==0 && <li className="list-group-item">None to assigned</li>}
                  {this.props.unmappedSuburbs.items.map(x => {
                    return (<li key={x.id} className="list-group-item">
                      <span>{x.name} - {x.postcode}</span>
                      <span className="pull-right" style={{marginLeft: 'auto'}}><Button color="primary" onClick={()=> this.handleSaveAssignSuburbFromRegion(x)}><i className="fa fa-chevron-right" /></Button></span>
                    </li>);
                  })}
                </ul>
                <h6 className="hidden-md-up">Region suburbs</h6>
                <ul className="col-md-6 list-group">
                  {this.state.selectedRegion.suburbs.length==0 && <li className="list-group-item">None assigned</li>}
                  {this.state.selectedRegion.suburbs.map(x => {
                    return (<li key={x.id} className="list-group-item">
                      <span>{x.name} - {x.postcode}</span>
                      <span className="pull-right" style={{marginLeft: 'auto'}}><Button color="danger" onClick={()=> this.handleRemoveSuburbFromRegion(x)}><i className="fa fa-times" /></Button></span>
                    </li>);
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> }
      {this.state.selectedSuburb && !this.state.newRegion.create && <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <h4>Assign {this.state.selectedSuburb.name} - {this.state.selectedSuburb.postcode}</h4>
          </div>
        </div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-horizontal">
              <div className="form-group row">
                <label className="col-md-1 form-control-label"  htmlFor="regions">Region</label>
                <div className="col-md-6">
                  <select
                    className="form-control custom-select"
                    onChange={this.handleRegionAssignTo}
                    value={this.state.assignedRegion}
                    name="regions"
                  >
                    <option value="0" key="0">Please select a region...</option>
                    {this.props.regions.items.map(x => {
                      return (<option value={x.id} key={x.id}>{x.name}</option>);
                    })}
                  </select>
                </div>
              </div>
              <div className="form-group row">
                <div className="offset-md-1 col-md-6">
                  <Button color="primary" onClick={this.handleSaveAssignSuburbToRegion}><i className="fa fa-save" />&nbsp;</Button>&nbsp;
                  <Button color="seconday" onClick={()=> this.setState({selectedSuburb: null, assignedRegion: 0})}><i className="fa fa-mail-reply" />&nbsp;</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> }
      {this.state.newRegion.create && <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <h4>New region</h4>
          </div>
        </div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-horizontal">
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="regions">Region name</label>
                <div className="col-md-8">
                  <Input type="text"
                         value={this.state.newRegion.name}
                         onChange={(e)=> this.setState({newRegion: {...this.state.newRegion, name: e.target.value}})}
                         name="regionName"
                         placeholder="Region name"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="isActive">Is active</label>
                <div className="col-md-6">
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox"
                             onChange={(e)=> this.setState({newRegion: {...this.state.newRegion, isInactive: !e.target.checked}})}
                             checked={!this.state.newRegion.isInactive}
                             name="isActive"
                      />
                    </Label>
                  </FormGroup>
                </div>

              </div>
              <div className="form-group row">
                <div className="offset-md-2 col-md-8">
                  <Button color="primary" onClick={this.handleCreateRegion}><i className="fa fa-save" />&nbsp;</Button>&nbsp;
                  <Button color="seconday" onClick={()=> this.setState({newRegion: {create: false}})}><i className="fa fa-mail-reply" />&nbsp;</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> }
    </div>);
  }
}

ManageRegionsPage.propTypes = {

};

function mapStateToProps(state){
  return {
    unmappedSuburbs: state.unmappedSuburbs,
    regions: state.regions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageRegionsPage);
